import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { IGridResult } from 'src/app/core/models/base';
import { IEmployee } from 'src/app/employee/employee';
import { ISearchTimeEntriesRequest, IStartTimeEntryRequest, ITimeEntry } from '../../models/time-entry';
import { ITimeEntryCategory } from '../../models/time-entry-category';
import { TimeEntryService } from '../../services/time-entry.service';
import { TimeEntriesStorageService } from '../../storage/time-entries-storage.service';
import { currentEmployeeSelector } from 'src/app/stores/global/current-employee/current-employee.store';
import { AppStateInterface } from 'src/app/stores/global/appState.interface';
import { Store } from '@ngrx/store';
@UntilDestroy()
@Component({
    selector: 'app-my-time-tracking',
    templateUrl: './my-time-tracking.component.html',
    styleUrls: ['./my-time-tracking.component.scss'],
    standalone: false
})
export class MyTimeTrackingComponent implements OnInit {

  constructor(
    private route : ActivatedRoute,
    private timeEntriesStorage : TimeEntriesStorageService,
    private asyncPipe: AsyncPipe,
    private store: Store<AppStateInterface>
  ) { }

  timeEntriesGrid$ : Observable<IGridResult<ITimeEntry[]>> =
    this.timeEntriesStorage.timeEntriesGrid$;

  currentEmployee$: Observable<IEmployee> =
  this.store.select(currentEmployeeSelector);

  timeEntryCategories: ITimeEntryCategory[] = [];

  mask = "00:00";

  searchRequest: ISearchTimeEntriesRequest = {
    pageNumber: 1,
    pageSize: 25,
    employeeId: null,
    dateFrom: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000),
    dateTo: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000),
    orderBy:['Date','Start']
  }
  
  ngOnInit(): void {
    this.timeEntryCategories = this.route.snapshot.data.timeEntryCategories as ITimeEntryCategory[];

    this.currentEmployee$
    .pipe(untilDestroyed(this))
    .subscribe(employee => {
      if(employee){
        this.searchRequest.employeeId = employee.id;
        this.timeEntriesStorage.listRequest = this.searchRequest;
      }
    })
  }

  reloadTimeEntries(){
    this.timeEntriesStorage.listTimeEntrys()
  }
}
